export const JEEmockFaq = [
    {
        targetId: '1',
        heading: '1. What is the Aakash OPEN MOCK TEST for JEE Main?',
        bulletpoints: [],
        subheading:
            'It is a full-length, JEE Main–pattern online test designed to help students assess their readiness, identify weak areas, and experience the exact difficulty and format of the actual exam.',
    },
    {
        targetId: '2',
        heading: '2. Who can appear for this Open Test?',
        bulletpoints: [],
        subheading:
            'Any JEE Main aspirant (Class 12 or 12th pass) can appear. It is open for both Aakash and non-Aakash students.',
    },
    {
        targetId: '3',
        heading: '3. Is there any registration fee?',
        bulletpoints: [],
        subheading: 'No. The mock test is completely free of cost.',
    },
    {
        targetId: '4',
        heading: '4. How do I register for the test?',
        bulletpoints: [],
        subheading: 'Students can register through Insert URL.',
    },
    {
        targetId: '5',
        heading: '5. What syllabus will the Open Test cover?',
        bulletpoints: [],
        subheading:
            'The test strictly follows the latest JEE Main syllabus as prescribed by NTA.',
    },
    {
        targetId: '6',
        heading: '6. What is the test pattern?',
        bulletpoints: [],
        subheading:
            'The test mirrors the official JEE Main pattern, including the number of questions, difficulty level, marking scheme, and total duration.',
    },
    {
        targetId: '7',
        heading: '7. Will I receive a detailed performance report?',
        bulletpoints: [
            'Score & accuracy',
            'Chapter-wise performance',
            'Predicted All-India Rank',
        ],
        subheading: '',
    },
    {
        targetId: '8',
        heading: '8. Can I attempt the test again?',
        bulletpoints: [],
        subheading:
            'No. Each student is allowed one attempt to ensure fairness and authenticity of results.',
    },
    {
        targetId: '9',
        heading: '9. What if I face technical issues during the test?',
        bulletpoints: [],
        subheading:
            'A dedicated technical support team will be available during the test.',
    },
    {
        targetId: '10',
        heading: '10. When will the exam be held?',
        bulletpoints: [],
        subheading:
            'The exam is scheduled for 28th Dec 2025, 4th Jan 2026, and 11th Jan 2026. You must start your exam anytime within the six-hour start window on your chosen exam date (11:00 AM – 5:00 PM).',
    },
    {
        targetId: '11',
        heading: '11. How do I take the test?',
        bulletpoints: [],
        subheading:
            'Use a laptop/desktop or mobile (via Aakash JEE NEET App and Website both) with a stable internet connection and the latest Chrome/Safari browser.',
    },
    {
        targetId: '12',
        heading: '12. When and how will I get my result?',
        bulletpoints: [],
        subheading:
            'After completing the exam, your score will be released instantly. A detailed report including AIR and SWOT analysis will be released within 24 to 48 hours.',
    },
    {
        targetId: '13',
        heading: '13. Will there be negative marking?',
        bulletpoints: [],
        subheading:
            'Yes. The marking scheme will follow the official JEE Main pattern, including negative marking in MCQs.',
    },
    {
        targetId: '14',
        heading: '14. What is the exam mode and medium?',
        bulletpoints: [],
        subheading: 'The exam mode is online and conducted in English & Hindi.',
    },
];

